"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _browserHistory = require("./browserHistory");

var routes = _interopRequireWildcard(require("./utils/routes"));

var _navigate = require("./utils/routes/navigate");

var _ScrollToTop = _interopRequireDefault(require("./components/ScrollToTop"));

var _PrivateRoute = _interopRequireDefault(require("./containers/PrivateRoute"));

var _Landing = _interopRequireDefault(require("./scenes/Landing"));

var _AppContainer = require("./containers/AppContainer/AppContainer");

var _Issues = _interopRequireDefault(require("./scenes/Issues"));

var _ProjectSettings = _interopRequireDefault(require("./scenes/ProjectSettings"));

var _SingleActionScene = require("./scenes/Action/SingleActionScene");

var _RedirectLogin = require("./scenes/Login/RedirectLogin");

var _UserAdmin = _interopRequireDefault(require("./scenes/UserAdmin"));

var _UserProfile = _interopRequireDefault(require("./scenes/UserProfile"));

var _NotFound = _interopRequireDefault(require("./containers/NotFound/NotFound"));

var _Analysis = require("./scenes/Analysis");

var _analysis = require("./context/analysis");

var _insights = require("./context/insights");

var _locale = require("./context/locale");

var _FeatureFlagsProvider = require("./context/feature-flags/FeatureFlagsProvider");

var _session = require("./context/session");

/* eslint-disable @typescript-eslint/explicit-function-return-type */

/* eslint-disable no-unused-vars */
// Rounting utilities
// Scene Components
// Legacy routes
// TODO: Refactor or remove when possible
// Kill With Fire components
const AppRouter = () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
  history: _browserHistory.history
}, /*#__PURE__*/_react.default.createElement(_ScrollToTop.default, null, /*#__PURE__*/_react.default.createElement(_AppContainer.AppContainer, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  exact: true,
  path: "/",
  component: _Landing.default
}), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  path: "/settings/:insightType",
  component: _ProjectSettings.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  from: "/triage/:syncoId/:ruleId",
  to: (0, _navigate.getLinkTo)(routes.INSIGHT_EQUIPS)
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  from: "/triage",
  to: (0, _navigate.getLinkTo)(routes.INSIGHTS)
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  from: "/insights",
  to: (0, _navigate.getLinkTo)(routes.INSIGHTS)
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  from: "/monitoring",
  to: (0, _navigate.getLinkTo)(routes.MONITORING)
}), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  path: routes.ANALYSIS,
  component: _Analysis.AnalysisScene
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  from: "/issues",
  to: routes.ACTIONS
}), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  exact: true,
  path: routes.ACTIONS,
  component: _Issues.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
  exact: true,
  from: "/issue/:actionId",
  to: routes.VIEW_ACTION
}), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  exact: true,
  path: routes.VIEW_ACTION,
  component: _SingleActionScene.SingleActionScene
}), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  exact: true,
  path: routes.USER_PROFILE,
  component: _UserProfile.default
}), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
  exact: true,
  path: routes.USER_ADMIN,
  component: _UserAdmin.default
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  path: "/login",
  component: _RedirectLogin.RedirectLogin
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  path: "/logout",
  component: _RedirectLogin.RedirectLogin
}), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _NotFound.default
})))));

const Root = () => /*#__PURE__*/_react.default.createElement(_session.SessionProvider, {
  refreshInterval: 1000 * 3600
}, /*#__PURE__*/_react.default.createElement(_locale.LocaleProvider, null, /*#__PURE__*/_react.default.createElement(_FeatureFlagsProvider.FeatureFlagsProvider, null, /*#__PURE__*/_react.default.createElement(_analysis.AnalysisProvider, null, /*#__PURE__*/_react.default.createElement(_insights.InsightsProvider, null, /*#__PURE__*/_react.default.createElement(AppRouter, null))))));

var _default = Root;
exports.default = _default;
module.exports = exports.default;